import to from "await-to-js";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// import style from "./ProductBrandsData.module.scss";
import { Table } from "../../../../../../components/Table/Table";
import { ModalsContext } from "../../../../../../context/modals.context";
import { ExciseStampsContext } from "../../../../../../modules/obligee/exciseStamps/exciseStamps.context";
import { exciseStampsService } from "../../../../../../modules/obligee/exciseStamps/exciseStamps.service";

export const ProductBrandsData = () => {
  const { exciseStamps, setExciseStamps } = useContext(ExciseStampsContext);
  const { setError } = useContext(ModalsContext);
  const [totalData, setTotalData] = useState(1);
  const { t } = useTranslation();

  const colDef = [
    { title: t("TABLES.SIFRA_PROIZVODA"), dataIndex: "sifra" },
    { title: t("TABLES.NAZIV_MARKE_PROIZVODA"), dataIndex: "naziv" },
  ];
  const postPodaciOMarkamaProizvoda = async (
    page: number | null,
    pageSize: number | null
  ) => {
    const [err, res] = await to(
      exciseStampsService.postPodaciOMarkamaProizvoda({
        markicaKategorijeId: exciseStamps.kategorijaProizvodaId,
        filter: {
          pageNumber: page,
          pageSize: pageSize,
        },
      })
    );
    if (err || !res.success) return setError(res?.errorMessage);
    setTotalData(res.data.totalCount);
    setExciseStamps({
      podaciOMarkamaProizvoda: res.data.result,
    });
  };

  useEffect(() => {
    postPodaciOMarkamaProizvoda(1, 20);
  }, []);

  return (
    <div>
      <Table
        columns={colDef}
        scrollConfig={[".ant-tabs-nav"]}
        pagination={{
          total: totalData,
          onChange: (page, pageSize) => {
            postPodaciOMarkamaProizvoda(page, pageSize);
          },
        }}
        dataSource={exciseStamps.podaciOMarkamaProizvoda}
        name="podaci-o-markama-proizvoda-tabela"
      />
    </div>
  );
};
